<template>
    <v-card flat style="
    min-height: 150px; color: rgb(var(--v-theme-light)); background-position: left center;
    background-color:#ff9999;
    background-position:top center;
    background-repeat:no-repeat;
    background-size:100% auto;
    background-size: cover;
    " class="pa-6" :style="{
        'background-image': 'linear-gradient(to ' + computedDirection + ', ' + hexToRgbA(color, 0) + ' 0%, ' + hexToRgbA(color, 0) + ' 20%,' + hexToRgbA(color, 1) + ' 100%), url(' + image + ')',
    }">
        <v-container fluid style="display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 100%;"
                 :class="$vuetify.display.name == 'xs' ? 'pa-0' : ''"
                >
            <v-row style="justify-content: center;">
                <v-col>
                    <v-container fluid class="pa-0">
                        <v-row>
                            <v-col>

                                <h2>{{ $t("landing." + item + ".title") }}</h2>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <p>{{ $t("landing." + item + ".text") }}</p>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="auto" class="py-0 pr-0" v-for="(key, keyIndex) in $t('landing.' + item + '.tags').split(' - ')">
                               {{key}}
                               <v-icon v-if="keyIndex < $t('landing.' + item + '.tags').split(' - ').length - 1">mdi-circle-small</v-icon>
                            </v-col>
                        </v-row>

                        <v-row v-if="!isMobile" v-for="(key, keyIndex) in $t('landing.' + item + '.subtextNonMobile').split(' - ')">
                            <v-col style="font-size: larger" cols="auto" class="py-2">
                               {{key}}
                             </v-col>
                        </v-row>
                    </v-container>
                </v-col>

                <v-col :cols="computedDirection == 'left' ? 'auto' : 12" style="
                display: flex;
                align-items: flex-end;
                justify-content: center;">
                    <img style="height: 150px" :src="icon" :alt="'Icon für ' + $t('landing.' + item + '.title')" />
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
export default {
    name: "landingCard",
    props: ["item", "image", "color", "icon", "direction"],

    computed: {
        computedDirection() {
            if (this.isMobile)
                return "top"
            return this.direction || "left"
        },


        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
    },

    methods: {
        hexToRgbA(hex, alpha) {
            var c;
            if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
                c = hex.substring(1).split('');
                if (c.length == 3) {
                    c = [c[0], c[0], c[1], c[1], c[2], c[2]];
                }
                c = '0x' + c.join('');
                return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + alpha + ')';
            }
            throw new Error('Bad Hex');
        }
    }
}
</script>